import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/game-cover.png'


const _withScopeId = n => (_pushScopeId("data-v-40baa11d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "game-start" }
const _hoisted_2 = { class: "game-start__content" }
const _hoisted_3 = { class: "game-start__inner-content" }
const _hoisted_4 = ["src", "width", "height"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { id: "header" }, "Welcome Art Student!", -1))
const _hoisted_6 = { class: "game-start__form" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Parrot cover",
  class: "game-start__cover"
}, null, -1))

import { useGameStore, GameStatus } from '@/stores/gameStore';
import { useUserStore } from '@/stores/userStore';
import router from '@/router';
import { computed, onMounted, watch } from 'vue';
import TextInput from '@/components/TextInput.vue';
import LogIn from '@/assets/VueIcons/IconLogIn.vue';
import IconComponent from '@/components/IconComponent.vue';
import { ROUTES } from '@/router/routes';
import FooterComponent from '@/features/FooterComponent.vue';
import MobileFooterComponent from '@/features/MobileFooterComponent.vue';
import { isPhone } from '@/utils/responsiveHelper';
import { useKeyboardStore } from '@/stores/keyboardStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'GameStartView',
  setup(__props) {

const gameStore = useGameStore();
const userStore = useUserStore();
const keyboardStore = useKeyboardStore();

const logoSize = computed(() => {
  if (!isPhone()) {
    return '245px';
  } else {
    return keyboardStore.isExpanded ? '100px' : '180px';
  }
});

function startNewGame() {
  gameStore.status = GameStatus.InProgress;
  router.push(ROUTES.DIALOG);
}

watch(
  () => keyboardStore.isExpanded,
  (newValue, _) => {
    if (newValue) {
      setTimeout(() => {
        window.scrollBy({ top: -150, behavior: 'auto' });
      }, 100);
    }
  }
);

onMounted(() => {
  userStore.resetUserState();
  gameStore.resetGameStateForNewGame();
  keyboardStore.setExpanded(false);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: require('@/assets/images/moaf-logo.svg'),
          width: logoSize.value,
          height: logoSize.value,
          alt: "logo",
          class: "game-start__logo"
        }, null, 8, _hoisted_4),
        _createElementVNode("div", null, [
          _hoisted_5,
          _createElementVNode("p", null, _toDisplayString(_unref(isPhone)()
                ? `Perfect the art of forgery with AI descriptions, but beware – you have only three lives to avoid getting caught.`
                : `Do you want to become a master of art forgery to fool the art
            appreciation? Then you have to forge images using your description
            and the power of AI. But be careful not to get caught because you
            only have three lives.`), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(TextInput, {
            placeHolder: "Invisible Fairy",
            onEnter: startNewGame,
            labelName: "Artist Name"
          }),
          _createElementVNode("button", {
            type: "submit",
            class: "primary-button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (startNewGame())),
            disabled: _unref(userStore).name === ''
          }, [
            _createTextVNode(" Get Started "),
            _createVNode(IconComponent, null, {
              default: _withCtx(() => [
                _createVNode(LogIn)
              ]),
              _: 1
            })
          ], 8, _hoisted_7)
        ]),
        (_unref(isPhone)())
          ? (_openBlock(), _createBlock(MobileFooterComponent, {
              key: 0,
              location: 'start'
            }))
          : (_openBlock(), _createBlock(FooterComponent, {
              key: 1,
              location: 'start'
            }))
      ])
    ]),
    _hoisted_8
  ]))
}
}

})